import { MessageCircle } from 'lucide-react';

export function EcoAssistContextButton({ children, context = '', className = '' }) {
  const openAssist = () => window.dispatchEvent(new CustomEvent('eco:assist-open', { detail: { context } }));
  return <button type="button" onClick={openAssist} className={`eco-btn-secondary ${className}`} data-testid="eco-assist-context-cta"><MessageCircle size={16} />{children}</button>;
}
